//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import Main from "@/views/Main"
import { ProviderList, ShowProvider, ShowPurchaseOrder, ShowInvoice, } from "@/views/Purchase/PchProvider"

//
export default {
    path: "providers",
    component: ModuleLayout,
    children: [
        {
            path: "",
            name: "providers-list",
            component: ProviderList,
        },
        {
            path: ":id",
            component: Main,
            children: [
                {
                    path: "",
                    name: "provider-update",
                    component: ShowProvider,
                    meta: {
                        title: "Detalle proveedor"
                    },
                },
                {
                    path: "purchase_orders/:pchId",
                    name: "providerPurchaseOrder",
                    component: ShowPurchaseOrder,
                    meta: {
                        title: "Detalle de orden de compra",
                    },
                },
                {
                    path: "invoice/:invId",
                    name: "providerInvoice",
                    component: ShowInvoice,
                    meta: {
                        title: "Detalle de orden de compra",
                    },
                },
            ],
        },
    ],
    meta: {
        title: "Proveedores"
    },
}
